import { render, staticRenderFns } from "./CoStreamUpdatesIndicator.vue?vue&type=template&id=46f0be56&scoped=true&"
import script from "./CoStreamUpdatesIndicator.vue?vue&type=script&lang=ts&"
export * from "./CoStreamUpdatesIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./CoStreamUpdatesIndicator.vue?vue&type=style&index=0&id=46f0be56&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f0be56",
  null
  
)

export default component.exports